import React, { useState, useContext } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { userContext } from './context/ContextProvider';

import Sidebar from './components/sidebar/Sidebar';
import supAdminNav from './components/sidebar/supAdminNav';
import adminNav from './components/sidebar/adminNav';
import TokenTest  from './components/Login/TokenTest';  // ✅ Add this import
import Login from './components/Login/Login';
import Unauthorized from './components/Login/Unauthorized';
import Dashboard from './components/dashboard/Dashboard';
import InventoryPage from './components/Inventory/Inventory';
import Employee from './components/Employee/Employee';
import CashManagement from './components/CashManagement/CashManagement';
import StockManagement from './components/StockManagement/StockManagement';
import ProductManagement  from './components/ProductManagement/ProductManagement';
import Sales from './components/Sales/Sales';
import CreateSalePage from './components/Sales/CreateSalePage';
import Expenses from './components/Expenses/Expenses';
import Category from './components/Category/Category';
import Department from './components/Department/Department';
import Designation from './components/Designation/Designation';
import Supplier from './components/Supplier/Supplier';
import Routee from './components/Routee/Routee';
import Customer from './components/Customer/Customer';
import Credit from './components/Credit/Credit';
import Cheque from './components/Cheque/Cheque';
import User from './components/User/User';
import Cash from './components/Cash/Cash';

import './components/sidebar/sidebar.css';
import './components/dashboard/Dashboard.css';
import './App.css';

// Role-based Route Wrapper
const RoleBasedRoute = ({ children, allowedRoles }) => {
  const { role } = useContext(userContext);
  const userRole = role?.toLowerCase() || 'admin';

  // Normalize role: 'superadmin' and 'supadmin' are the same
  const normalizedRole = userRole === 'superadmin' ? 'supadmin' : userRole;

  if (!allowedRoles.includes(normalizedRole)) {
    return <Navigate to="/unauthorized" replace />;
  }

  return children;
};

function App() {
  const [isSidebarOpen, setIsSidebarOpen] = useState(true);
  const { role, authenticated, loading } = useContext(userContext);

  const toggleSidebar = () => {
    setIsSidebarOpen(!isSidebarOpen);
  };

  // Show loading while context initializes
  if (loading) {
    return (
      <div
        style={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          height: '100vh',
          fontSize: '18px',
        }}
      >
        Loading...
      </div>
    );
  }

  // If not authenticated, show login/unauthorized routes only
  if (!authenticated) {
    return (
      <Router>
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route path="/unauthorized" element={<Unauthorized />} />
           <Route path="/token-test" element={<TokenTest />} />
          <Route path="*" element={<Navigate to="/login" replace />} />
        </Routes>
      </Router>
    );
  }

  // Get sidebar based on user role
  const userRole = role?.toLowerCase() || 'admin';

  const roleSidebar = {
    superadmin: supAdminNav,
    supadmin: supAdminNav,
    admin: adminNav,
    user: adminNav,
  };

  const sidebarTitle = {
    superadmin: 'Super Admin Dashboard',
    supadmin: 'Super Admin Dashboard',
    admin: 'Admin Dashboard',
    user: 'User Dashboard',
  };

  // Debug logging
  console.log('App Debug:', { userRole, navItems: roleSidebar[userRole], supAdminNav, adminNav });

  // If authenticated, show main dashboard layout
  return (
    <Router>
      <div className={`dashboard-container ${!isSidebarOpen ? 'sidebar-closed' : ''}`}>
        <Sidebar
          isOpen={isSidebarOpen}
          navItems={roleSidebar[userRole]}
          title={sidebarTitle[userRole]}
        />

        <div className="main-content">
          <Routes>
            {/* Routes accessible to all authenticated roles */}
            <Route path="/" element={<Dashboard toggleSidebar={toggleSidebar} />} />
            <Route
              path="/dashboard"
              element={<Dashboard toggleSidebar={toggleSidebar} />}
            />
            <Route
              path="/inventory"
              element={<InventoryPage toggleSidebar={toggleSidebar} />}
            />
            <Route
              path="/category"
              element={<Category toggleSidebar={toggleSidebar} />}
            />
            <Route
              path="/supplier"
              element={<Supplier toggleSidebar={toggleSidebar} />}
            />
            <Route
              path="/routee"
              element={<Routee toggleSidebar={toggleSidebar} />}
            />
            <Route
              path="/customer"
              element={<Customer toggleSidebar={toggleSidebar} />}
            />
            <Route
              path="/employees"
              element={<Employee toggleSidebar={toggleSidebar} />}
            />
            <Route
              path="/cash"
              element={<CashManagement toggleSidebar={toggleSidebar} />}
            />
            <Route
              path="/stock"
              element={<StockManagement toggleSidebar={toggleSidebar} />}
            />
            <Route
              path="/products"
              element={<ProductManagement toggleSidebar={toggleSidebar} />}
            />
            <Route
              path="/CreateSaleModal"
              element={<CreateSalePage toggleSidebar={toggleSidebar} />} 
            />
            <Route
              path="/sales"
              element={<Sales toggleSidebar={toggleSidebar} />}
            />
            <Route
              path="/expenses"
              element={<Expenses toggleSidebar={toggleSidebar} />}
            />
            <Route
              path="/credit"
              element={<Credit toggleSidebar={toggleSidebar} />}
            />
             <Route
              path="/cash"
              element={<CashManagement toggleSidebar={toggleSidebar} />}
            />
            <Route
              path="/cashh"
              element={<Cash toggleSidebar={toggleSidebar} />}
            />
            <Route
              path="/cheque"
              element={<Cheque toggleSidebar={toggleSidebar} />}
            />


            {/* Super Admin Only Routes */}
            <Route
              path="/department"
              element={
                <RoleBasedRoute allowedRoles={['supadmin']}>
                  <Department toggleSidebar={toggleSidebar} />
                </RoleBasedRoute>
              }
            />
            <Route
              path="/designation"
              element={
                <RoleBasedRoute allowedRoles={['supadmin']}>
                  <Designation toggleSidebar={toggleSidebar} />
                </RoleBasedRoute>
              }
            />
            <Route
              path="/user"
              element={
                <RoleBasedRoute allowedRoles={['supadmin']}>
                  <User toggleSidebar={toggleSidebar} />
                </RoleBasedRoute>
              }
            />

            {/* Catch all - redirect to dashboard */}
            <Route path="*" element={<Navigate to="/dashboard" replace />} />
          </Routes>
        </div>
      </div>
    </Router>
  );
}

export default App;